import Link from 'next/link';
import { Button } from '../ui/button';

export function StepSection({
  title,
  description,
  steps,
  image
}: {
  title: string;
  description: string;
  image: string;
  steps: {
    title: string;
    description: string;
    icon: React.ReactNode;
    link?: string;
    linkText?: string;
  }[];
}) {
  return (
    <section className="py-24">
      <div className="mx-auto max-w-xl md:max-w-6xl">
        <div className="grid items-center gap-12 md:grid-cols-2 md:gap-12 lg:grid-cols-5 lg:gap-24">
          <div className="lg:col-span-2">
            <div className="md:pr-6 lg:pr-0">
              <h2 className="text-4xl font-semibold lg:text-4xl font-domaine-narrow">
                {title}
              </h2>
              <p className="mt-6">{description}</p>
            </div>
            <ul className="mt-8 divide-y border-y">
              {steps.map(step => (
                <li
                  key={step.title}
                  className="flex items-center justify-between py-3"
                >
                  <div className="flex items-center gap-3">
                    {step.icon}
                    <span>{step.title}</span>
                  </div>
                  {step.link && (
                    <Link href={step.link}>
                      <Button variant="link" className="text-primary">
                        {step.linkText}
                      </Button>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="relative rounded-3xl border border-[#2665eb]/40 p-3 lg:col-span-3">
            <div className="bg-gradient-to-b aspect-76/59 relative rounded-2xl from-zinc-300 to-transparent p-px dark:from-zinc-700">
              <img
                src={image}
                className="rounded-[15px]"
                alt="payments illustration light"
                width={1207}
                height={929}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
